<template>
  <div class="gpt-translator">
    <section class="f-s-14">
      <div>
        <div class="d-f justify-b align-c">
          <div>
            <span class="title">GPT润色</span>
            <el-tooltip
              class="item"
              effect="dark"
              content="复制对应译文点击润色，GPT将会帮你润色，并将润色结果将展示在此处！"
              placement="top-start"
            >
              <i class="el-icon-question c-p c-primary"></i>
            </el-tooltip>
          </div>
          <i
            :class="[
              isShowPolish
                ? 'el-icon-arrow-up c-p c-primary f-w-600 f-s-18'
                : 'el-icon-arrow-down c-p c-primary f-w-600 f-s-18',
            ]"
            @click="isShowPolish = !isShowPolish"
          ></i>
        </div>
      </div>
      <section v-if="isShowPolish">
        <div class="border m-t-5 p-5 c-666">
          <span class="f-w-600">原译文：</span>
          <div class="oldText">{{ polishSrc }}</div>
        </div>
        <div class="border m-t-5 p-5 c-666">
          <span class="f-w-600">译文：</span>
          <div class="oldText">
            {{ loading ? '思考中...' : polishResult }}
          </div>
          <div class="t-r">
            <i
              class="el-icon-document-copy c-p"
              @click="copyPolishResult(polishResult, $event)"
            ></i>
          </div>
        </div>
      </section>
    </section>
    <section class="f-s-14 m-b-10">
      <div>
        <div class="d-f justify-b align-c">
          <div>
            <span class="title">GPT翻译</span>
            <el-tooltip
              class="item"
              effect="dark"
              content="复制对应译文点击翻译，GPT将会帮你重新翻译，并将翻译结果将展示在此处！"
              placement="top-start"
            >
              <i class="el-icon-question c-p c-primary"></i>
            </el-tooltip>
          </div>
          <i
            :class="[
              isShowTrans
                ? 'el-icon-arrow-up c-p c-primary f-w-600 f-s-18'
                : 'el-icon-arrow-down c-p c-primary f-w-600 f-s-18',
            ]"
            @click="isShowTrans = !isShowTrans"
          ></i>
        </div>
      </div>
      <section v-if="isShowTrans">
        <div class="border m-t-5 p-5 c-666">
          <span class="f-w-600">原文：</span>
          <div class="oldText">{{ transSrc }}</div>
        </div>
        <div class="border m-t-5 p-5 c-666">
          <span class="f-w-600">译文：</span>
          <div class="oldText">
            {{ loading ? '思考中...' : transResult }}
          </div>
          <div class="t-r">
            <i
              class="el-icon-document-copy c-p"
              @click="copyTransResult(transResult, $event)"
            ></i>
          </div>
        </div>
      </section>
    </section>
  </div>
</template>

<script>
import { gptCompletion, gptTran } from '@/api/qc/qcflow';
import clip from '@/util/clipboard';
import { jsonTextToText } from '@/components/rich-text';
import { statistics } from '@/api/dot/flow';
import { COPILOT_GPT_TRACKS } from './report';

export default {
  name: 'CopilotPanel',
  props: ['visible', 'slan', 'tlan', 'staParams'],
  data: () => {
    return {
      isShowPolish: false,
      isShowTrans: false,
      loading: false,
      transSrc: '',
      polishSrc: '',
      transResult: '',
      polishResult: '',
      currentRow: {},
    };
  },
  watch: {
    visible(val) {
      if (!val) {
        this.reset();
      }
    },
  },
  methods: {
    // 翻译
    toTrans(type, row) {
      this.reset();
      this.isShowTrans = true;
      this.currentRow = row;
      this.transSrc = jsonTextToText(row.srcText);
      this.loading = true;
      return gptTran({
        orderId: row.orderId,
        sentId: row.id,
        txt: this.transSrc,
        slan: this.slan,
        tlan: this.tlan,
      })
        .then((res) => {
          this.transResult = res.data?.data;
          this.copilotVisible = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 润色
    toPolish(type, row) {
      this.reset();
      this.isShowPolish = true;
      this.currentRow = row;
      //target--机翻译文， peTarget--PE译文
      this.polishSrc =
        type == 'target'
          ? jsonTextToText(row.mtText)
          : jsonTextToText(row.peTextOldShow ?? row.peTextShow);

      this.loading = true;
      return gptCompletion({
        orderId: row.orderId,
        sentId: row.id,
        txt: this.polishSrc,
        slan: this.slan,
        tlan: this.tlan,
      })
        .then((res) => {
          this.polishResult = res.data?.data;
          this.copilotVisible = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    copyTransResult(text, event) {
      if (!text) {
        return;
      }
      clip(text, event);

      statistics(
        Object.assign({}, this.staParams, COPILOT_GPT_TRACKS.tranCopy, {
          event_params: {
            sentId: this.currentRow.id,
          },
        }),
      );
    },
    copyPolishResult(text, event) {
      if (!text) {
        return;
      }
      clip(text, event);

      statistics(
        Object.assign({}, this.staParams, COPILOT_GPT_TRACKS.polishCopy, {
          event_params: {
            sentId: this.currentRow.id,
          },
        }),
      );
    },
    reset() {
      this.isShowPolish = false;
      this.isShowTrans = false;
      this.transResult = '';
      this.polishResult = '';
      this.transSrc = '';
      this.polishSrc = '';
    },
  },
};
</script>

<style lang="scss" scope>
.gpt-translator {
  .border {
    border-radius: 4px;
    margin-bottom: 15px;
  }
  .title {
    font-size: 16px;
    margin-bottom: 10px;
    margin-right: 5px;
  }
  .oldText {
    min-height: 100px;
    max-height: 120px;
    overflow-y: scroll;
    line-height: 22px;
    font-size: 13px;
    border-radius: 4px;
  }
}
</style>
